export default {
	
	validations: {
		required: "मान आवश्यक है।",
		email: "मान एक मान्य ईमेल पता नहीं है",
		minLength: "यह फ़ील्ड कम से कम ${min} वर्ण लंबा होना चाहिए",
		maxLength: "अधिकतम लंबाई की अनुमति ${max} है",
		minValue: "न्यूनतम मान की अनुमति ${min} है",
		maxValue: "अधिकतम अनुमत मूल्य ${max} है",
		numeric: "मान संख्यात्मक होना चाहिए",
		ipAddress: "मान एक मान्य IP पता नहीं है",
		sameAs: "मान ${otherName} मान के बराबर होना चाहिए",
	}
}